import React, { createContext, useCallback, useRef, useState } from 'react'

import { Modal } from 'antd'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { onError, onSuccess } from '../../utils/apiHelper'
import { getUser } from '../../reducers/UserReducer'
import { addInternshipRequestFile } from '../../utils/api/internshipRequest'
import InternshipRequestFileForm from '../../Components/shared/Forms/InternshipRequestFileForm'
import { ErrorMessages, HttpStatuses } from '../../utils/http'

export const InternshipRequestFileModalContext = createContext()

const DEFAULT_FILE = { data: null, callback: null }

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const InternshipRequestFileModal = ({ children, user, t }) => {
  const [selectedFile, setSelectedFile] = useState(DEFAULT_FILE)
  const [visible, setVisible] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)

  const handleSubmit = useCallback(({ data, file }, force = false) => {
    if (submittingRef.current) {
      return
    }

    submittingRef.current = true
    setSubmitting(true)

    addInternshipRequestFile(user, selectedFile.data.individualInternshipRequest, { file, type: data.type, force }).then(json => {
      if (json?.data) {
        onSuccess(t('internship_request_file.create.success'))

        if (selectedFile.callback) {
          selectedFile.callback(json.data)
        }
      }

      setSelectedFile(DEFAULT_FILE)
    }).catch(error => {
      if (error.code === HttpStatuses.CONFLICT && error.message === ErrorMessages.CONVENTION_ALREADY_EXISTS) {
        setVisible(() => () => handleSubmit({ data, file }, true))
        setSelectedFile(DEFAULT_FILE)
      } else {
        onError(t('internship_request_file.create.error'))
      }
    }).finally(() => {
      submittingRef.current = false
      setSubmitting(false)
    })
  }, [selectedFile, setSelectedFile, user, t])

  return (
    <>
      <InternshipRequestFileModalContext.Provider value={{ setSelectedFile }}>
        {children}
      </InternshipRequestFileModalContext.Provider>
      <Modal
        width={500}
        title={t('internship_request_file.title')}
        visible={!!selectedFile.data}
        onCancel={() => setSelectedFile(DEFAULT_FILE)}
        footer={null}
        destroyOnClose
      >
        <InternshipRequestFileForm
          item={selectedFile.data}
          loading={submitting}
          onSubmit={handleSubmit}
        />
      </Modal>
      <Modal
        visible={!!visible}
        title={t('common.warning')}
        okText={t('internship_request_file_modal.duplicate.ok_button')}
        cancelText={t('internship_request_file_modal.duplicate.cancel_button')}
        okButtonProps={{ type: 'danger' }}
        onOk={() => {
          visible()
          setVisible(null)
        }}
        onCancel={() => setVisible(null)}
      >
        {t('internship_request_file_modal.duplicate.body')}
      </Modal>
    </>
  )
}

export default connect(mapStateToProps)(InternshipRequestFileModal)
